import { ReferenceField, TextField } from "react-admin";
import * as React from "react";
import PropTypes from "prop-types";
import { getSecureRandom } from "../../../Helper/random";

const AcRegField = ({ source = "aircraftId", record, label, link }) => {
  return (
    <ReferenceField
      key={getSecureRandom()}
      label={label}
      source={source}
      reference="cdmaircraft"
      record={record}
      link={link}
    >
      <TextField source="acReg" />
    </ReferenceField>
  );
};

AcRegField.propTypes = {
  record: PropTypes.any,
  label: PropTypes.string,
  link: PropTypes.bool,
  source: PropTypes.string,
};

export default AcRegField;
